import FiveCardStarSpread from '../../components/oracle/FiveCardStarSpread';

const FiveCardStarSpreadPage = ({lang = 'es'}) => {
  return (
    <div className="bg-gray-900 min-h-screen pt-16">
      <FiveCardStarSpread lang={lang} />
    </div>
  );
};

export default FiveCardStarSpreadPage;